export default "__VITE_ASSET__ba93900b__"